var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-7.369 -7.369 30 30",
    enableBackground: "new -7.369 -7.369 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    fill: "#B6B6AC",
    d: "M17.572,13.775L17.572,13.775l-6.144-6.143l6.144-6.142l0,0 c0.245-0.248,0.245-0.646,0-0.894l-2.902-2.905c-0.248-0.246-0.647-0.246-0.895,0l0,0L7.628,3.838L1.486-2.304l0,0 c-0.248-0.247-0.648-0.247-0.894,0l-2.901,2.899c-0.246,0.248-0.246,0.646,0,0.894l0,0l6.143,6.143l-6.143,6.143l0,0 c-0.246,0.247-0.246,0.646,0,0.894l2.906,2.903c0.248,0.246,0.646,0.246,0.894,0l0,0l6.142-6.142l6.143,6.142l0,0 c0.248,0.246,0.647,0.246,0.894,0l2.902-2.902C17.818,14.421,17.818,14.023,17.572,13.775L17.572,13.775z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectGrey);
export default __webpack_public_path__ + "static/media/reject-grey.dc3bf3bceb15f3a1278155323eb90fb4.svg";
export { ForwardRef as ReactComponent };